import React from 'react';
import classNames from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import { UserFile } from 'hellospa/page/prep-and-send/data/types/file';
import FileStatus from './file-status';
import styles from './styles.scss';
import { DragSort, DropResult } from 'hellospa/components/drag-sort';
import { Dispatch } from 'hellospa/redux/types';
import { useDispatch } from 'react-redux';
import * as actions from 'hellospa/page/prep-and-send/data/actions/file';

const messages = defineMessages({
  file: {
    id: '',
    defaultMessage: 'file',
    description: 'Will be used in other messages before a filename',
  },
});

type Props = {
  files: UserFile[],
};

export default function FilesStatus({ files }: Props) {
  const dispatch = useDispatch<Dispatch>();
  const intl = useIntl();

  // sorting the files, so it shows up in the order it was uploaded or set
  const sorted = files.sort((a, b) => a.order - b.order);

  const handleDrop = React.useCallback((drop: DropResult<UserFile>) => {
    const from = sorted[drop.from];
    const to = sorted[drop.to];

    dispatch(actions.reorderFile(from.rootSnapshotGuid, from.order, to.order));
  }, [dispatch, sorted]);

  // if no files, nothing to render
  if (files.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <div className={classNames(styles.filesStatusList)}>
        <DragSort
          onDrop={handleDrop}
          data={sorted}
          messageValues={(file) => ({
            name: file.name,
            type: intl.formatMessage(messages.file),
          })}
          getProps={(file) => ({
            key: file.rootSnapshotGuid,
            file,
          })}
          component={FileStatus} />
      </div>
    </React.Fragment>
  );
}
